module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar app-navbar animated",
    class: {
      slideInDown: _vm.show, slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_vm._m(0), _c('div', {
    staticClass: "navbar-burger {'is-active': sidebar.opened}",
    on: {
      "click": function($event) {
        _vm.toggleSidebar({
          opened: !_vm.sidebar.opened
        })
      }
    }
  }, [_c('span'), _c('span'), _c('span')])]), _c('div', {
    staticClass: "navbar-menu navbar-end"
  }, [_c('div', {
    staticClass: "navbar-item has-dropdown is-hoverable"
  }, [_c('router-link', {
    staticClass: "navbar-link",
    attrs: {
      "to": "/settings"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-cog"
  })]), _vm._v("Settings")]), _c('div', {
    staticClass: "navbar-dropdown is-right"
  }, [_vm._m(1), _vm._l((_vm.api.options), function(opt) {
    return _c('a', {
      staticClass: "navbar-item",
      attrs: {
        "data-value": opt.name
      },
      on: {
        "click": _vm.setEndpoint
      }
    }, [_vm._v(_vm._s(opt.name))])
  }), _c('hr', {
    staticClass: "navbar-divider"
  }), _c('div', {
    staticClass: "navbar-item"
  }, [_vm._v("Version: " + _vm._s(_vm.pkginfo.version))])], 2)], 1), (!_vm.auth) ? _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/login"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-key"
  })]), _vm._v(" Login")]) : _vm._e(), (_vm.auth) ? _c('a', {
    staticClass: "navbar-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(2), _vm._v(" Logout")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "hero-brand navbar-item",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/icon.png")
    }
  }), _c('span', {
    staticClass: "is-hidden-mobile"
  }, [_c('span', {
    staticClass: "co-name"
  }, [_vm._v("Triseum")]), _c('strong', {
    staticClass: "admin"
  }, [_vm._v("Admin")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-item"
  }, [_c('b', [_vm._v("Endpoints")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a57e1e2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/layout/Navbar.vue
// module id = 120
// module chunks = 11